import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import React, { useContext, /* useState, */ useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Message /* , Icon */ } from 'semantic-ui-react';
import { Form } from '../../../../../../../../../form-elements/Form';
import { LabeledInput } from '../../../../../../../../../form-elements/inputs/LabeledInput';
import { ShouldRender } from '../../../../../../../../../ShouldRender';
import { Grid } from '../../../../../../../../../layout/Grid';
// import { Radio } from '../../../../../../../../../form-elements/radios/Radio';
import { Brikk } from '../../../../../../../../../Brikk';
import { Text } from '../../../../../../../../../typography';
// import { DeleteUser } from '../../../Users/components/DeleteUser';
import styles from '../../../../styles.module.scss';
// import { Services } from '../../../Services/Services';
// import { ShowMoreButton } from '../../../../../../../../../form-elements/buttons/ShowMoreButton';
import { useUpdateUser } from '../../../../../../../../../../services/admin/update-user';
import { useUserPermissions } from '../../../../../../../../../../services/user/permissions';
import { adminUserSchema } from '../../../../../../../../../../utils/validation/schemas';
import { useModal } from '../../../../../../../../../../store/modals';
import { ManageAccessToServices } from '../ManageAccessToServices';
import { UserAdministrationModalContext } from '../../../../UserAdministrationModalContext';
import { useUserPermissionsByEmail } from '../../../../../../../../../../services/user/permissions/permissions-by-email';
import { PageLoader } from '../../../../../../../../../loaders/PageLoader';
import { useAllUsers } from '../../../../../../../../../../services/admin/get-all-users';
import { useGetUserIn2n } from '../../../../../../../../../../services/2n/get-user';

export const UserForm = () => {

  const {
    selectedUser,
    setSelectedUser,
    // service, setService,
  } = useContext(UserAdministrationModalContext);
  // const [showMoreServices, setShowMoreServices] = useState(false);
  const allUsers = useAllUsers();

  const { checkPermission } = useUserPermissions();
  const canUpdate = checkPermission('admin-users', 'update');
  // const canDelete = checkPermission('admin-users', 'delete');
  const userPermissionsByEmail = useUserPermissionsByEmail(selectedUser && selectedUser.email);
  const { openModal, isModalOpen } = useModal();

  const isConfirmationModalOpen = isModalOpen('ConfirmationModal');

  const { updateUser, isLoading, isSuccess } = useUpdateUser({
    onSuccess: () => {
      if (!isConfirmationModalOpen && isSuccess) {
        setTimeout(() => {
          openModal({
            modalType: 'NotificationModal',
            modalProps: {
              type: 'success',
              description: 'updateUserSuccess',
            },
          });
        }, 100);
      }
    },
  });

  const {
    control,
    handleSubmit,
    reset,
    formState: { isDirty, errors },
  } = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(adminUserSchema),
    defaultValues: {
      firstName: (selectedUser && selectedUser.firstName) || '',
      lastName: (selectedUser && selectedUser.lastName) || '',
      email: (selectedUser && selectedUser.email) || '',
      phone:
        (selectedUser && selectedUser.phone) || '',
      mobilephone: (selectedUser && selectedUser.mobilephone) || '',
      workphone: (selectedUser && selectedUser.workphone) || '',
      objectId: (selectedUser && selectedUser.objectId) || '',
      address: (selectedUser && selectedUser.address) || '',
      addressId: (selectedUser && selectedUser.addressId) || '',
      postalCode: (selectedUser && selectedUser.postalCode) || '',
    },
  });

  useEffect(() => {
    if (selectedUser) {
      reset({
        firstName: selectedUser.firstName || '',
        lastName: selectedUser.lastName || '',
        email: selectedUser.email || '',
        phone: selectedUser.phone || '',
        mobilephone: selectedUser.mobilephone || '',
        workphone: selectedUser.workphone || '',
        objectId: selectedUser.objectId || '',
        address: selectedUser.address || '',
        addressId: selectedUser.addressId || '',
        postalCode: selectedUser.postalCode || '',
      });
    }
  }, [selectedUser, reset]);

  const onSubmit = async (data) => {
    await updateUser({
      userId: selectedUser.id,
      userData: {
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        phone: data.phone,
        mobilephone: data.mobilephone,
        workphone: data.workphone,
        objectId: data.objectId,
        address: data.address,
        addressId: data.addressId,
        postalCode: data.postalCode,
      },
    });
  };

  const getUserIn2n = useGetUserIn2n(selectedUser?.email);
  const showSelectedUser = userPermissionsByEmail && !userPermissionsByEmail.isLoading ? selectedUser : null;

  if (userPermissionsByEmail?.isLoading
     || allUsers?.isLoading
     || getUserIn2n?.isLoading
  ) return <div className={styles.container}><PageLoader /></div>;

  return (
    <div className={styles.container}>

      <Brikk.Heading
        heading="userAdminBrikk"
      />

      {showSelectedUser ? (
        <>
          <Form
            id="edit-user-form"
            className={styles.formContainer}
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className={styles.formWrapper}>
              <Grid
                noPadding
                oneColumn
              >
                <div className={styles.form}>

                  <Controller
                    name="firstName"
                    control={control}
                    render={({ field: { ref, onChange, value } }) => (
                      <LabeledInput
                        labelIntl="firstName"
                        id="first-name"
                        value={value}
                        inputRef={ref}
                        onChange={onChange}
                        hasError={!!errors.firstName}
                        readOnly={!canUpdate}
                      />
                    )}
                  />

                  <ShouldRender condition={!!errors.firstName}>
                    <Message negative>
                      <Message.Content>
                        <FormattedMessage
                          id={errors.firstName?.message}
                          defaultMessage=""
                        />
                      </Message.Content>
                    </Message>
                  </ShouldRender>

                  <Controller
                    name="lastName"
                    control={control}
                    render={({ field: { ref, onChange, value } }) => (
                      <LabeledInput
                        labelIntl="lastName"
                        id="family-name"
                        value={value}
                        inputRef={ref}
                        onChange={onChange}
                        hasError={!!errors.lastName}
                        readOnly={!canUpdate}
                      />
                    )}
                  />

                  <ShouldRender condition={!!errors.lastName}>
                    <Message negative>
                      <Message.Content>
                        <FormattedMessage
                          id={errors.lastName?.message}
                          defaultMessage=""
                        />
                      </Message.Content>
                    </Message>
                  </ShouldRender>

                  <Controller
                    name="email"
                    control={control}
                    render={({ field: { ref, onChange, value } }) => (
                      <LabeledInput
                        labelIntl="email"
                        id="email"
                        type="email"
                        value={value}
                        inputRef={ref}
                        onChange={onChange}
                        hasError={!!errors.email}
                        readOnly={!canUpdate}
                      />
                    )}
                  />

                  <ShouldRender condition={!!errors.email}>
                    <Message negative>
                      <Message.Content>
                        <FormattedMessage
                          id={errors.email?.message}
                          defaultMessage=""
                        />
                      </Message.Content>
                    </Message>
                  </ShouldRender>

                  <Controller
                    name="mobilephone"
                    control={control}
                    render={({ field: { ref, onChange, value } }) => (
                      <LabeledInput
                        labelIntl="mobilePhone"
                        id="mobilePhone"
                        value={value}
                        inputRef={ref}
                        onChange={onChange}
                        hasError={!!errors.mobilephone}
                        readOnly={!canUpdate}
                      />
                    )}
                  />

                  <ShouldRender condition={!!errors.mobilephone}>
                    <Message negative>
                      <Message.Content>
                        <FormattedMessage
                          id={errors.mobilephone?.message}
                          defaultMessage=""
                        />
                      </Message.Content>
                    </Message>
                  </ShouldRender>

                  <Controller
                    name="workphone"
                    control={control}
                    render={({ field: { ref, onChange, value } }) => (
                      <LabeledInput
                        labelIntl="phoneWork"
                        id="workPhone"
                        value={value}
                        inputRef={ref}
                        onChange={onChange}
                        hasError={!!errors.workphone}
                        readOnly={!canUpdate}
                      />
                    )}
                  />

                  <ShouldRender condition={!!errors.workphone}>
                    <Message negative>
                      <Message.Content>
                        <FormattedMessage
                          id={errors.workphone?.message}
                          defaultMessage=""
                        />
                      </Message.Content>
                    </Message>
                  </ShouldRender>

                  <Controller
                    name="phone"
                    control={control}
                    render={({ field: { ref, onChange, value } }) => (
                      <LabeledInput
                        labelIntl="phoneHome"
                        id="homePhone"
                        value={value}
                        inputRef={ref}
                        onChange={onChange}
                        hasError={!!errors.phone}
                        readOnly={!canUpdate}
                      />
                    )}
                  />

                  <ShouldRender condition={!!errors.phone}>
                    <Message negative>
                      <Message.Content>
                        <FormattedMessage
                          id={errors.phone?.message}
                          defaultMessage=""
                        />
                      </Message.Content>
                    </Message>
                  </ShouldRender>

                  <Controller
                    name="objectId"
                    control={control}
                    render={({ field: { ref, onChange, value } }) => (
                      <LabeledInput
                        labelIntl="aptNo"
                        id="apartmentNumber"
                        value={value}
                        inputRef={ref}
                        onChange={onChange}
                        hasError={!!errors.objectId}
                        readOnly={!canUpdate}
                      />
                    )}
                  />

                  <ShouldRender condition={!!errors.objectId}>
                    <Message negative>
                      <Message.Content>
                        <FormattedMessage
                          id={errors.objectId?.message}
                          defaultMessage=""
                        />
                      </Message.Content>
                    </Message>
                  </ShouldRender>

                  <Controller
                    name="address"
                    control={control}
                    render={({ field: { ref, onChange, value } }) => (
                      <LabeledInput
                        labelIntl="address"
                        id="address"
                        value={value}
                        inputRef={ref}
                        onChange={onChange}
                        hasError={!!errors.address}
                        readOnly={!canUpdate}
                      />
                    )}
                  />

                  <ShouldRender condition={!!errors.address}>
                    <Message negative>
                      <Message.Content>
                        <FormattedMessage
                          id={errors.address?.message}
                          defaultMessage=""
                        />
                      </Message.Content>
                    </Message>
                  </ShouldRender>

                  <Controller
                    name="addressId"
                    control={control}
                    render={({ field: { ref, onChange, value } }) => (
                      <LabeledInput
                        labelIntl="addressId"
                        id="addressId"
                        value={value}
                        inputRef={ref}
                        onChange={onChange}
                        hasError={!!errors.addressId}
                        readOnly={!canUpdate}
                      />
                    )}
                  />

                  <ShouldRender condition={!!errors.addressId}>
                    <Message negative>
                      <Message.Content>
                        <FormattedMessage
                          id={errors.addressId?.message}
                          defaultMessage=""
                        />
                      </Message.Content>
                    </Message>
                  </ShouldRender>

                  <Controller
                    name="postalCode"
                    control={control}
                    render={({ field: { ref, onChange, value } }) => (
                      <LabeledInput
                        labelIntl="postalCode"
                        id="postalCode"
                        value={value}
                        inputRef={ref}
                        onChange={onChange}
                        hasError={!!errors.postalCode}
                        readOnly={!canUpdate}
                      />
                    )}
                  />

                  <ShouldRender condition={!!errors.postalCode}>
                    <Message negative>
                      <Message.Content>
                        <FormattedMessage
                          id={errors.postalCode?.message}
                          defaultMessage=""
                        />
                      </Message.Content>
                    </Message>
                  </ShouldRender>

                  {/* Uncomment once BE implementation is done*/}
                  {/* <Grid
              noPadding
              oneColumn
              style={{
                gridGap: '10px',
              }}
              justifyItems="start"
            >
              ...existing code...
            </Grid> */}
                </div>
              </Grid>
            </div>

            {canUpdate && (
            <div className={styles.actionContainer}>

              <ManageAccessToServices />

              <div className={styles.formButtons}>
                <Button
                  basic
                  name="cancel-user-details"
                  type="button"
                  disabled={isLoading}
                  onClick={() => setSelectedUser(null)}
                >
                  <FormattedMessage id="cancel" />
                </Button>
                <Button
                  primary
                  type="submit"
                  name="submit-user-details"
                  disabled={!isDirty || isLoading}
                  loading={isLoading}
                >
                  <FormattedMessage id="saveChanges" />
                </Button>
              </div>
            </div>
            )}
          </Form>

          {/*<ShouldRender condition={selectedUser && canDelete}>*/}
          {/*  <Grid*/}
          {/*    noPadding*/}
          {/*    oneColumn*/}
          {/*    justifyItems="end"*/}
          {/*  >*/}
          {/*    <DeleteUser />*/}
          {/*  </Grid>*/}
          {/*</ShouldRender>*/}
        </>
      ) : (
        <Text
          secondary
          center
          intl="noUserSelected"
          size={16}
        />
      )}
    </div>
  );
};
